import { Component } from '@angular/core';
import { Router , ActivatedRoute } from '@angular/router';
import { ProjectConfigurationService } from './global_services/project_config.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {


  constructor(private route: ActivatedRoute, private projectConfigurationService: ProjectConfigurationService, private router: Router) {

  }


videoIdFormater(url:String):String{
  const regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
  var match = url.match(regExp);
  return (match&&match[7].length==11)? match[7] : url;

}

  ngOnInit() {

  }

}
